<template>
  <div class="users f-c-b f-d-c w-100 h-100 p-4 pb-22 o-f-a">
    <div class="myusers f-s-s f-d-c w-100 p-3 h-100">
      <div id="finance" class="w-100 h-100 f-c-s f-d-c pt-2">
    <div
      v-if="financeCategoriesData.plan_status"
      class="statusSec w-100 f-s-s f-d-c pr-4"
    >
      <div class="planName f-c-c">
        {{ "پلن فعال" + " : " + financeCategoriesData.plan_title }}
      </div>
      <div class="planName f-c-c">
        {{
          "تعداد روز باقیمانده" + " : " + financeCategoriesData.plan_remain_days
        }}
      </div>
    </div>
    <div class="categoryList f-c-sa mb-5 mt-4">
      <div
        v-for="(v, i) in catList"
        :key="i"
        class="f-c-c cat"
        @click.prevent="tabClickFunc(i)"
        :class="[tabId == i ? 'activeTab' : '']"
      >
        {{ v.name }}
      </div>
    </div>
    <div class="boxSec f-c-sa f-w-w">
      <div class="financeCard f-s-s f-d-c" v-for="(f, j) in plans" :key="j">
        <div class="header f-c-s w-100">{{ f.title }}</div>
        <div class="body f-s-s f-w-w w-100">
          <div class="bodyItem f-c-b w-100">
            <div class="f-c-c label">تعداد روز</div>
            <div class="value f-c-c">
              {{ f.days_num }}
            </div>
          </div>
          <div class="bodyItem f-c-b w-100">
            <div class="f-c-c label">کاربر همزمان</div>
            <div class="value f-c-c">
              {{ f.concurrent_user }}
            </div>
          </div>
          <div class="bodyItem f-c-b w-100">
            <div class="f-c-c label">ویدئو همزمان</div>
            <div class="value f-c-c">
              {{ f.concurrent_video }}
            </div>
          </div>
          <div class="bodyItem f-c-b w-100">
            <div class="f-c-c label">قیمت</div>
            <div class="value f-c-c">
              {{ f.price }}
            </div>
          </div>
        </div>
        <div class="footer w-100 f-c-e">
          <div class="buyBtn f-c-c" @click.prevent="buyPlanFunc(f)">خرید</div>
        </div>
      </div>
    </div>
  </div>
    </div>
  </div>
</template>
<script>
import { mapState, mapActions } from "vuex";
export default {
  name: "Finance",
  data() {
    return {
      tabId: 0,
      catList: [],
      plans: [],
    };
  },
  created() {
    this.getFinanceCategoriesFunction({
      user_id: this.user.user_id,
    });
  },
  computed: {
    ...mapState({
      user: (state) => state.gap.user,
      financeCategoriesData: (state) => state.gap.financeCategoriesData,
      buyPlaneStatus: (state) => state.gap.buyPlaneStatus,
    }),
  },
  components: {},
  methods: {
    ...mapActions("gap", ["getFinanceCategoriesFunction", "buyPlaneFunction"]),
    tabClickFunc(i) {
      this.tabId = i;
      this.plans = this.catList[i].plans;
    },
    buyPlanFunc(p) {
      this.buyPlaneFunction({
        user_id: this.user.user_id,
        plan_id: p.id,
      });
    },
  },
  watch: {
    financeCategoriesData(n) {
      if (Object.keys(n).length) {
        this.catList = n.categories;
        this.plans = n.categories[0].plans;
      }
    },
    buyPlaneStatus(n) {
      if (Object.keys(n).length) {
        if (n.code == 100) {
          this.getFinanceCategoriesFunction({
            user_id: this.user.user_id,
          });
          this.$bvToast.toast(n.message, {
            title: "ثبت",
            variant: "success",
            solid: true,
          });
        }
      }
    },
  },
  mounted() {},
};
</script>